import { Bot, CheckCircle2, Heart, MapPin, Sparkles } from "lucide-react";

const COLS = [["Saved", 12, "bg-[#D4AF37]"], ["Applied", 8, "bg-sky-400"], ["Interviews", 3, "bg-violet-400"], ["Offer", 1, "bg-emerald-400"]];

const Ring = ({ v = 92 }) => {
  const r = 22, c = 2 * Math.PI * r;
  return (
    <div className="relative h-14 w-14 shrink-0">
      <svg viewBox="0 0 56 56" className="h-14 w-14 -rotate-90">
        <circle cx="28" cy="28" r={r} stroke="#27272A" strokeWidth="5" fill="none" />
        <circle cx="28" cy="28" r={r} stroke="url(#lp-gold)" strokeWidth="5" fill="none" strokeLinecap="round"
          strokeDasharray={c} strokeDashoffset={c * (1 - v / 100)} className="lp-ring" style={{ "--c": c }} />
        <defs><linearGradient id="lp-gold" x1="0" x2="1"><stop offset="0" stopColor="#D4AF37" /><stop offset="1" stopColor="#F3C649" /></linearGradient></defs>
      </svg>
      <span className="absolute inset-0 flex items-center justify-center font-mono text-sm font-bold text-[#F3C649]">{v}</span>
    </div>
  );
};

export const AppPreview = () => (
  <div className="lp-float relative" data-testid="login-app-preview">
    <div className="absolute -inset-6 rounded-[32px] bg-[#D4AF37]/10 blur-3xl" />
    <div className="relative overflow-hidden rounded-2xl border border-[#D4AF37]/25 bg-[#121214]/95 shadow-[0_24px_60px_rgba(0,0,0,0.7)] backdrop-blur-2xl">
      <div className="flex items-center gap-2 border-b border-[#27272A] px-4 py-2.5">
        <span className="h-2.5 w-2.5 rounded-full bg-zinc-700" /><span className="h-2.5 w-2.5 rounded-full bg-zinc-700" /><span className="h-2.5 w-2.5 rounded-full bg-zinc-700" />
        <span className="ml-3 truncate font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500">rpopro.co<span className="hidden sm:inline"> / command center</span></span>
        <span className="ml-auto flex shrink-0 items-center gap-1 rounded-full bg-[#33290D] px-2 py-0.5 text-[10px] font-semibold text-[#F3C649]"><Heart className="h-3 w-3" />Well-Being</span>
      </div>
      <div className="space-y-3 p-4">
        <div className="flex items-center gap-4 rounded-xl border border-[#27272A] bg-[#18181B] p-3.5">
          <Ring />
          <div className="min-w-0 flex-1">
            <div className="truncate text-sm font-medium text-zinc-100">Senior Product Manager</div>
            <div className="mt-0.5 flex items-center gap-1 truncate text-xs text-zinc-500">Northwind Labs · <MapPin className="h-3 w-3" />Remote</div>
            <div className="mt-2 flex flex-wrap gap-1.5">
              <span className="flex items-center gap-1 rounded-full border border-emerald-500/30 bg-emerald-500/10 px-2 py-0.5 font-mono text-[10px] font-bold text-emerald-400"><CheckCircle2 className="h-3 w-3" />ATS PASS</span>
              <span className="flex items-center gap-1 rounded-full border border-[#D4AF37]/30 bg-[#33290D] px-2 py-0.5 text-[10px] text-[#F3C649]"><Sparkles className="h-3 w-3" />Resume tailored</span>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-4 gap-2">
          {COLS.map(([l, n, dot], i) => (
            <div key={l} className="lp-rise rounded-lg border border-[#27272A] bg-[#18181B] p-2.5" style={{ animationDelay: `${700 + i * 120}ms` }}>
              <div className="flex items-center gap-1.5"><span className={`h-1.5 w-1.5 rounded-full ${dot}`} /><span className="truncate text-[9px] uppercase tracking-wide text-zinc-500 sm:tracking-widest">{l}</span></div>
              <div className="mt-1 font-mono text-lg font-semibold text-zinc-100">{n}</div>
            </div>
          ))}
        </div>
        <div className="rounded-xl border border-[#D4AF37]/20 bg-[#33290D]/40 p-3">
          <div className="flex items-center gap-2 text-xs text-zinc-300">
            <span className="relative flex h-2 w-2"><span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#D4AF37] opacity-60" /><span className="relative h-2 w-2 rounded-full bg-[#D4AF37]" /></span>
            <Bot className="h-3.5 w-3.5 text-[#D4AF37]" />Auto-Apply Agent preparing 5 tailored applications
          </div>
          <div className="mt-2.5 h-1 overflow-hidden rounded-full bg-[#27272A]"><div className="lp-bar h-full rounded-full bg-gradient-to-r from-[#D4AF37] to-[#F3C649]" /></div>
        </div>
      </div>
    </div>
  </div>
);
